import React, { useEffect, useState } from 'react'
import { Link } from 'react-router'

function Index() {

  const [properties, setProperties] = useState([])

  useEffect(() => {
    fetch("/properties.json")
      .then(res => res.json())
      .then(data => setProperties(data))
  }, [])

  return (
    <div>
      <div className="main-banner">
        <div className="owl-carousel owl-banner">
          <div className="item item-1">
            <div className="header-text">
              <span className="category">Toronto, <em>Canada</em></span>
              <h2>Hurry!<br />Get the Best Villa for you</h2>
            </div>
          </div>
          <div className="item item-2">
            <div className="header-text">
              <span className="category">Melbourne, <em>Australia</em></span>
              <h2>Be Quick!<br />Get the best villa in town</h2>
            </div>
          </div>
          <div className="item item-3" >
            <div className="header-text">
              <span className="category">Miami, <em>South Florida</em></span>
              <h2>Act Now!<br />Get the highest level penthouse</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="featured section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="left-image">
                <img src="assets/images/featured.jpg" />
                <Link to={"propertydetails"}><img src="assets/images/featured-icon.png" style={{ maxWidth: 60, padding: 0 }} /></Link>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="section-heading">
                <h6>| Featured</h6>
                <h2>Best Appartment &amp; Sea view</h2>
              </div>
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Best useful links ?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Discover our curated selection of resources designed to simplify your property search. From our comprehensive buying guides and current market analysis reports to our mortgage calculator tools, we provide everything you need to make an informed investment. We also partner with top-tier interior designers and legal experts to ensure your transition into a new home is seamless and stress-free.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      How does this work ?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Our process is designed to be transparent and client-focused. First, we conduct a detailed consultation to understand your specific lifestyle needs and budget. Next, we use our exclusive network to find properties that aren't always listed on the public market. Once we find your dream villa, our experienced agents handle all the negotiations and paperwork, ensuring you get the best possible value while we manage the complexities of the closing process.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Why is Villa Agency the best ?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      Villa Agency stands out because we prioritize integrity and local expertise above all else. With over 12 years of experience in the luxury market, we don't just sell houses; we build lasting relationships based on trust. Our team offers a personalized concierge service that goes beyond the sale, providing 24/7 support and deep insights into the most prestigious neighborhoods, ensuring your new home is a perfect match for your future.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="info-table">
                <ul>
                  <li>
                    <img src="assets/images/info-icon-01.png" style={{ maxWidth: 52 }} />
                    <h4>250 m2<br /><span>Total Flat Space</span></h4>
                  </li>
                  <li>
                    <img src="assets/images/info-icon-02.png" style={{ maxWidth: 52 }} />
                    <h4>Contract<br /><span>Contract Ready</span></h4>
                  </li>
                  <li>
                    <img src="assets/images/info-icon-03.png" style={{ maxWidth: 52 }} />
                    <h4>Payment<br /><span>Payment Process</span></h4>
                  </li>
                  <li>
                    <img src="assets/images/info-icon-04.png" style={{ maxWidth: 52 }} />
                    <h4>Safety<br /><span>24/7 Under Control</span></h4>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="video section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 offset-lg-4">
              <div className="section-heading text-center">
                <h6>| Video View</h6>
                <h2>Get Closer View &amp; Different Feeling</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="video-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="video-frame">
                <img src="assets/images/video-frame.jpg" />
                <a href="https://youtube.com" target="_blank"><i className="fa fa-play" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fun-facts">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="wrapper">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="counter">
                      <h2 className="timer count-title count-number" data-to={34} data-speed={1000} />
                      <p className="count-text ">Buildings<br />Finished Now</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="counter">
                      <h2 className="timer count-title count-number" data-to="12" data-speed={1000} />
                      <p className="count-text ">Years<br />Experience</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="counter">
                      <h2 className="timer count-title count-number" data-to={24} data-speed={1000} />
                      <p className="count-text ">Awwards<br />Won 2023</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section best-deal">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="section-heading">
                <h6>| Best Deal</h6>
                <h2>Find Your Best Deal Right Now!</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="tabs-content">
                <div className="row">
                  <div className="nav-wrapper ">
                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="appartment-tab" data-bs-toggle="tab" data-bs-target="#appartment" type="button" role="tab" aria-controls="appartment" aria-selected="true">Appartment</button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="villa-tab" data-bs-toggle="tab" data-bs-target="#villa" type="button" role="tab" aria-controls="villa" aria-selected="false">Villa House</button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="penthouse-tab" data-bs-toggle="tab" data-bs-target="#penthouse" type="button" role="tab" aria-controls="penthouse" aria-selected="false">Penthouse</button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="appartment" role="tabpanel" aria-labelledby="appartment-tab">
                      <div className="row">
                        <div className="col-lg-3">
                          <div className="info-table">
                            <ul>
                              <li>Total Flat Space <span>185 m2</span></li>
                              <li>Floor number <span>26th</span></li>
                              <li>Number of rooms <span>4</span></li>
                              <li>Parking Available <span>Yes</span></li>
                              <li>Payment Process <span>Bank</span></li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <img src="assets/images/deal-01.jpg" />
                        </div>
                        <div className="col-lg-3">
                          <h4>Extra Info About Property</h4>
                          <p>Experience the perfect blend of comfort and convenience in our premium city apartments. Designed for the modern professional, these units feature open-concept layouts that maximize natural light and urban views. Every apartment comes equipped with energy-efficient appliances and high-speed fiber connectivity.
                            <br /><br />Living here means you are just steps away from the city's vibrant business district, top-rated dining, and public transit. Our community also offers secure underground parking and a private fitness center available 24/7 for all residents.</p>
                          <div className="icon-button">
                            <Link to={"propertydetails"}><i className="fa fa-calendar" /> Schedule a visit</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="villa" role="tabpanel" aria-labelledby="villa-tab">
                      <div className="row">
                        <div className="col-lg-3">
                          <div className="info-table">
                            <ul>
                              <li>Total Flat Space <span>250 m2</span></li>
                              <li>Floor number <span>26th</span></li>
                              <li>Number of rooms <span>5</span></li>
                              <li>Parking Available <span>Yes</span></li>
                              <li>Payment Process <span>Bank</span></li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <img src="assets/images/deal-02.jpg" />
                        </div>
                        <div className="col-lg-3">
                          <h4>Detail Info About Villa</h4>
                          <p>Our Luxury Villas offer an unparalleled level of privacy and elegance for those seeking a sanctuary to call home. These properties feature expansive private gardens, custom-built swimming pools, and outdoor entertainment areas perfect for family gatherings.
                            <br /><br />Inside, you will find artisanal masonry, soaring ceilings, and dedicated wings for guest suites or home offices. Nestled in quiet, gated communities, these villas provide a serene lifestyle without compromising on proximity to the region's most prestigious international schools and golf courses.</p>
                          <div className="icon-button">
                            <Link to={"propertydetails"}><i className="fa fa-calendar" /> Schedule a visit</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="penthouse" role="tabpanel" aria-labelledby="penthouse-tab">
                      <div className="row">
                        <div className="col-lg-3">
                          <div className="info-table">
                            <ul>
                              <li>Total Flat Space <span>320 m2</span></li>
                              <li>Floor number <span>34th</span></li>
                              <li>Number of rooms <span>6</span></li>
                              <li>Parking Available <span>Yes</span></li>
                              <li>Payment Process <span>Bank</span></li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <img src="assets/images/deal-03.jpg" />
                        </div>
                        <div className="col-lg-3">
                          <h4>Extra Info About Penthouse</h4>
                          <p>Define your lifestyle with our crown-jewel penthouses, offering 360-degree panoramic views of the skyline and coast. These exclusive residences feature private elevator access, wrap-around terraces, and floor-to-ceiling glass walls that redefine luxury living.
                            <br /><br />Each penthouse is a masterpiece of architectural design, featuring smart-home automation, climate-controlled wine cellars, and spa-inspired primary bathrooms. As a penthouse owner, you enjoy priority concierge services and exclusive access to rooftop amenities that are simply unmatched in the city.</p>
                          <div className="icon-button">
                            <Link to={"propertydetails"}><i className="fa fa-calendar" /> Schedule a visit</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="properties section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 offset-lg-4">
              <div className="section-heading text-center">
                <h6>| Properties</h6>
                <h2>We Provide The Best Property You Like</h2>
              </div>
            </div>
          </div>
            <div className="row">
              {
                properties.slice(0, 6).map((items)=>{
                
                  const propDetails = items.details[0];

                return (
                  <div className="col-lg-4 col-md-6" key={items.id}>
                  <div className="item">
                      <Link to={"propertydetails"}><img src={items.image} style={{ height: "270px" }} /></Link>
                    <span className="category">{items.luxury}</span>
                    <h6>{items.price}</h6>
                    <h4><Link to={"propertydetails"}>{items.name}</Link></h4>
                    <ul>
                      <li>Bedrooms: <span>{propDetails.Bedrooms}</span></li>
                      <li>Bathrooms: <span>{propDetails.Bathrooms}</span></li>
                      <li>Area: <span>{propDetails.Area}</span></li>
                      <li>Floor: <span>{propDetails.Floor}</span></li>
                      <li>Parking: <span>{propDetails.Parking}</span></li>
                    </ul>
                    <div className="main-button">
                        <Link to={"propertydetails"}>Schedule a visit</Link>
                    </div>
                  </div>
                </div>
                )
                })
              }
            </div>
            <div className="row text-center mt-5">
                <div className="col-lg-12 d-flex justify-content-end">
                    <div className="main-button">
                        <Link to="/properties">View All Properties</Link>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div className="contact section">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 offset-lg-4">
                <div className="section-heading text-center">
                  <h6>| Contact Us</h6>
                  <h2>Get In Touch With Our Agents</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div id="map">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12469.776493332698!2d-80.14036379941481!3d25.907788681148624!2m3!1f357.26927939317244!2f20.870722720054623!3f0!3m2!1i1024!2i768!4f35!3m3!1m2!1s0x88d9add4b4ac788f%3A0xe77469d09480fcdb!2sSunny%20Isles%20Beach!5e1!3m2!1sen!2sth!4v1642869952544!5m2!1sen!2sth" width="100%" height="500px" frameBorder={0} style={{ border: 0, borderRadius: 10, boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)' }} allowFullScreen />
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="item phone">
                      <img src="assets/images/phone-icon.png" style={{ maxWidth: 52 }} />
                      <h6>010-020-0340<br /><span>Phone Number</span></h6>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="item email">
                      <img src="assets/images/email-icon.png" style={{ maxWidth: 52 }} />
                      <h6>info@villa.co<br /><span>Business Email</span></h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <form id="contact-form" method="post">
                  <div className="row">
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="name">Full Name</label>
                        <input type="name" name="name" id="name" placeholder="Your Name..." autoComplete="on" required />
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="email">Email Address</label>
                        <input type="text" name="email" id="email" pattern="[^ @]*@[^ @]*" placeholder="Your E-mail..." required />
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="subject">Subject</label>
                        <input type="subject" name="subject" id="subject" placeholder="Subject..." autoComplete="on" />
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="message">Message</label>
                        <textarea name="message" id="message" placeholder="Your Message" defaultValue={""} />
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <button type="submit" id="form-submit" className="orange-button">Send Message</button>
                      </fieldset>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      )
}

      export default Index